import api from '../api'

const baseUrl = '/academy/api/PostComment'

const skillUpCommentsProvider = {
  getUserComment(payload) {
    return api.post(`${baseUrl}/GetById`, payload)
  },
  setStatus(payload) {
    return api.put(`${baseUrl}/Status`, payload)
  },
  replyToComment(payload) {
    return api.post(`${baseUrl}/AddReply`, payload)
  },
  editReplyToComment(payload) {
    return api.post(`${baseUrl}/EditReply`, payload)
  },
  deleteReplyToComment(payload) {
    return api.delete(`${baseUrl}/DeleteReply`, { data: payload })
  },
}

export default skillUpCommentsProvider
